import { PIcon } from '@porsche-design-system/components-react';
import { type FormItemProps as AntdFormItemProps } from 'antd';
import { isEmpty } from 'lodash/fp';
import styled from 'styled-components';
import { WrapHelp } from '../../../components/fields/FormItem';
import { BaseFormItem } from '../../default/Calculator/FormItem';
import { formItemCss } from '../Fields/shared';

const StyledBaseFormItem = styled(BaseFormItem)`
    & .ant-form-item-row {
        & .ant-col:last-child {
            /* Porsche v3 should it's error on the bottom, to prevent sibling field going down */
            justify-content: start;
        }
    }
    & .ant-form-item-label {
        /* Porsche v3 should it's error on the bottom, to prevent sibling field going down */
        flex-grow: unset;
    }

    &.ant-form-item-has-error {
        transition: 0.3s;
        border: var(--calculator-form-item-error-border);

        & input {
            ::placeholder {
                color: rgb(1, 2, 5);
            }
            ::-ms-input-placeholder {
                color: rgb(1, 2, 5);
            }
        }
    }

    &.calculator-form-item-label {
        ${formItemCss}

        & .ant-form-item-explain-error {
            padding-left: 0;
            margin-bottom: auto;
        }

        &.form-item-disabled .ant-form-item-label p-text.hydrated {
            color: var(--calculator-field-disabled-label-color, rgba(0, 0, 0, 0.25));
        }
    }
`;

/**
 * Form Item calculator, this one, make sure that help props is included
 */
const FormItem = ({ help, ...props }: AntdFormItemProps) => (
    <StyledBaseFormItem
        {...props}
        help={
            !isEmpty(help) && (
                <WrapHelp
                    errorIcon={
                        <PIcon
                            aria={{ 'aria-label': 'Exclamation icon' }}
                            color="notification-error"
                            name="exclamation"
                        />
                    }
                    errorMessage={help}
                    hasError={!isEmpty(help)}
                />
            )
        }
    />
);

export default FormItem;
